// style-loader: Adds some css to the DOM by adding a <style> tag
var dispose = require("!/root/explorio/node_modules/style-loader/addStyle.js")
	// The css code:
	(require("!!/root/explorio/node_modules/css-loader/index.js!/root/explorio/node_modules/autoprefixer-loader/index.js!/root/explorio/node_modules/stylus-loader/index.js!/root/explorio/src/styles/index.styl"));
// Hot Module Replacement
if(module.hot) {
	module.hot.accept();
	module.hot.dispose(dispose);
}


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.styl
// module id = 1
// module chunks = 0